"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Popconfirm = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _antd = require("antd");
var _Icon = require("./Icon.style");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Icon組件
 */

const materialIconType = {
  default: "material-icons",
  outLined: "material-icons-outlined",
  twoTone: "material-icons-two-tone",
  rounded: "material-icons-round",
  sharp: "material-icons-sharp"
};
const Icon = _ref => {
  let {
    name,
    type = "default",
    rotate,
    color,
    bgcolor,
    onClick,
    mr,
    disabled,
    clickable = false,
    focus,
    focuscolor
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Icon.UiIcon, {
    rotate: rotate,
    color: disabled ? "#e7e7ed" : color,
    bgcolor: bgcolor,
    focus: focus,
    focuscolor: focuscolor,
    onClick: onClick,
    mr: mr,
    disabled: disabled,
    clickable: clickable
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: materialIconType[type]
  }, name));
};
const Popconfirm = _ref2 => {
  let {
    name,
    type = "default",
    rotate,
    color,
    bgcolor,
    mr,
    disabled,
    clickable = false,
    icon,
    focuscolor,
    title = "內文唷",
    getPopupContainer = () => document.getElementById("IconPop"),
    onConfirm = () => {}
  } = _ref2;
  const [popup, setPopup] = (0, _react.useState)(false);
  const onConfirmHandle = () => {
    setPopup(false);
    onConfirm();
  };
  return /*#__PURE__*/_react.default.createElement(_Icon.UiIconPop, {
    id: "IconPop"
  }, /*#__PURE__*/_react.default.createElement(_antd.Popconfirm, {
    placement: "bottom",
    title: title,
    icon: icon,
    visible: popup,
    onConfirm: onConfirmHandle,
    onCancel: () => setPopup(false),
    okText: "\u78BA\u5B9A",
    cancelText: "\u53D6\u6D88",
    getPopupContainer: getPopupContainer
  }, /*#__PURE__*/_react.default.createElement(Icon, {
    name: name,
    type: type,
    focus: popup,
    focuscolor: focuscolor,
    rotate: rotate,
    color: disabled ? "#e7e7ed" : color,
    bgcolor: bgcolor,
    onClick: () => setPopup(true),
    mr: mr,
    disabled: disabled,
    clickable: clickable
  })));
};
exports.Popconfirm = Popconfirm;
var _default = exports.default = Icon;
Icon.propTypes = {
  name: _propTypes.default.string,
  type: _propTypes.default.string,
  rotate: _propTypes.default.number,
  color: _propTypes.default.string,
  bgcolor: _propTypes.default.string,
  onClick: _propTypes.default.func,
  mr: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  clickable: _propTypes.default.bool,
  focus: _propTypes.default.bool,
  focuscolor: _propTypes.default.string
};
Popconfirm.propTypes = {
  name: _propTypes.default.string,
  type: _propTypes.default.string,
  rotate: _propTypes.default.number,
  color: _propTypes.default.string,
  focuscolor: _propTypes.default.string,
  bgcolor: _propTypes.default.string,
  onClick: _propTypes.default.func,
  mr: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  clickable: _propTypes.default.bool,
  icon: _propTypes.default.any,
  title: _propTypes.default.string,
  onConfirm: _propTypes.default.func,
  getPopupContainer: _propTypes.default.any
};